import { FC } from 'react'
import { Stack } from '@mui/material'

import Logo from '@/assets/svg/logo.svg'
import Pattern from '@/assets/svg/pattern.svg'
import GreyLogo from '@/assets/svg/grey-logo.svg'
import Benzinga from '@/assets/svg/benzinga.svg'
import MarketWatch from '@/assets/svg/market-watch.svg'
import MorningStar from '@/assets/svg/morning-star.svg'
import Yahoo from '@/assets/svg/yahoo.svg'
import MarketInsider from '@/assets/svg/market-insider.svg'
import LeftCurve from '@/assets/svg/left-curve.svg'
import Calendar from '@/assets/svg/calendar.svg'
import Linkedin from '@/assets/svg/linkedin.svg'
import Telegram from '@/assets/svg/telegram.svg'
import Discord from '@/assets/svg/discord.svg'
import LocationOn from '@/assets/svg/location-on.svg'
import Email from '@/assets/svg/mail.svg'
import Phone from '@/assets/svg/phone.svg'

export const ICON_MAP = {
  logo: Logo,
  pattern: Pattern,
  'grey-logo': GreyLogo,
  benzinga: Benzinga,
  'market-watch': MarketWatch,
  'morning-star': MorningStar,
  yahoo: Yahoo,
  'market-insider': MarketInsider,
  'left-curve': LeftCurve,
  calendar: Calendar,
  linkedin: Linkedin,
  telegram: Telegram,
  discord: Discord,
  'location-on': LocationOn,
  email: Email,
  phone: Phone
}

export type IconName = keyof typeof ICON_MAP

interface AppIconProps {
  name: IconName
  width?: string | number
  height?: string | number
  className?: string
  size?: number
  colors?: string
  borderRadius?: string
  ariaLabel?: string
}

export const AppIcon: FC<AppIconProps> = ({
  name,
  colors,
  size = 20,
  height,
  width,
  borderRadius,
  className = '',
  ariaLabel,
  ...props
}) => {
  const IconComponent = ICON_MAP[name]

  if (!IconComponent) {
    console.error(`Icon "${name}" not found.`)

    return null
  }

  return (
    <Stack
      className={`app-icon ${className}`}
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        width: 'max-content',

        color: colors,
        '& svg': { width: width || size, height: height || size, borderRadius: borderRadius }
      }}
      {...props}
    >
      <IconComponent />
    </Stack>
  )
}
